import { isEmpty, path } from 'ramda'
import { createSelector } from 'reselect'

const getLocks = state => state.omnitecLocks

export const selectLocksFetching = state => path(['omnitecLocks', 'isFetching'], state)

export const selectLocks = createSelector(getLocks, locks => {
    if (!(isEmpty(locks.entities) || isEmpty(locks.result))) {
        const items = locks.entities.omnitecLocks
        return items
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/omnitecSelectors/omnitecLocks.js